import { render, staticRenderFns } from "./PerformanceTargetResultsDetailsDialog.vue?vue&type=template&id=ff5e356c"
import script from "./PerformanceTargetResultsDetailsDialog.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetResultsDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports